import { ReactNode } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

interface BoxTextProps {
  children: ReactNode;
}

export default function BoxText({ children }: BoxTextProps) {
  return <Container>{children}</Container>;
}

const Container = styled.span`
  ${({ theme }) => css`
    padding: 2px 4px;
    border: 1px solid ${theme.content.content_light_3};
    border-radius: 4px;
    color: ${theme.content.content_light_3};
    text-align: center;
    ${theme.fontStyle.text.caption_medium};
  `}
`;
